
<div>
    <div class="faq-container">

        <div>
          <h2 class="faq-title">Come leggere il risultato della ricerca</h2>
        </div>
    
        <div class="row">

            @for(col of faqCols; track col.id) {
                <div class="col-sm-6">
                    @for (item of col.items; track item.id) {
                        <div class="faq-item">
                            <div class="faq-item-title">
                                <span (click)="item.isExpanded = !item.isExpanded"><i class="fa-solid fa-caret-{{item.isExpanded ? 'down' : 'right'}} pe-1"></i> {{item.title}}</span>
                            </div>
                            <div class="faq-item-content" [hidden]="!item.isExpanded" [innerHTML]="item.content"></div>
                        </div>
                    }
                </div>
            }

        </div>
    
        <!-- <app-glossary></app-glossary> -->
    
      </div>
    
      <!-- <div class="w-100 mt-4">
          <app-contenuti-correlati></app-contenuti-correlati>
      </div> -->
</div>